export enum ChamadoStatusEnum {
  AGUARDANDO = 'AGUARDANDO',
  EM_ATENDIMENTO = 'EM_ATENDIMENTO',
  FECHADO = 'FECHADO',
}
